module.exports = __webpack_public_path__ + "img/arrow-square-down.a976b1df.svg";